import { type ReactNode } from 'react'
import { useScrollOffsets } from '@/hooks/element-hooks'
import styles from './Staffing.module.css'
import { StaffingHeader } from '@/features/admin/staffing/components/StaffingHeader'
import {
  SideSheetHostView,
  SideSheetMain,
  SideSheet,
} from '@/components/SideSheet'
import { TableHost } from '@/components/Table'
import { TableScroller } from '@/components/Table/TableScroller'
import { TableSearchbar } from '@/components/TableSearchbar'
import { ContentLayout } from '@/components/ContentLayout'
import { WorkspacePostingCount } from '@/features/admin/staffing/components/WorkspacePostingCount'

export interface StaffingProps {
  /**
   * The workspace filter shown as the header's heading.
   */
  heading: ReactNode
  onNewPost: () => unknown
  isSideSheetVisible?: boolean
  statusFilter: ReactNode
  postingCount: number
  searchText: string
  onSearchTextChange: (text: string) => void
  table: ReactNode
  detailsPanel: ReactNode
  /**
   * The posting dialogs and the applicant management panel.
   */
  children?: ReactNode
}

export function Staffing({
  heading,
  onNewPost,
  isSideSheetVisible,
  statusFilter,
  postingCount,
  searchText,
  onSearchTextChange,
  table,
  detailsPanel,
  children,
}: StaffingProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <div className={styles.root}>
      <SideSheetHostView sheetVisible={isSideSheetVisible}>
        <SideSheetMain>
          <div className={styles.mainContainer} ref={scrollRef}>
            <StaffingHeader scrollOffset={scrollOffset} onNewPost={onNewPost}>
              {heading}
            </StaffingHeader>
            {statusFilter}
            <WorkspacePostingCount count={postingCount} />
            <ContentLayout>
              <TableHost>
                <TableSearchbar
                  searchText={searchText}
                  onSearchTextChange={onSearchTextChange}
                />
                <TableScroller>{table}</TableScroller>
              </TableHost>
            </ContentLayout>
          </div>
        </SideSheetMain>
        <SideSheet>{detailsPanel}</SideSheet>
      </SideSheetHostView>
      {children}
    </div>
  )
}
